import { render, staticRenderFns } from "./TrashIcon.vue?vue&type=template&id=bc338b74&scoped=true&"
var script = {}
import style0 from "./TrashIcon.vue?vue&type=style&index=0&id=bc338b74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc338b74",
  null
  
)

export default component.exports